import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import PriceComponent from './PriceComponent'
import Modal from 'react-bootstrap/Modal'
import Footer from '../Footer/Footer'
import { Alert, Row, Spinner } from 'react-bootstrap'
import {
  API_ERROR_MESSAGE,
  DISCLAIMER,
  _initialState,
} from '../../utils/Constants'
import './kycStyle.css'
import SidebarMenu from 'react-bootstrap-sidebar-menu'
import DirectorEnquiry from '../../screens/DirectorEnquiry/DirectorEnquiry'
import RealTimeIdv from '../../screens/RealTimeIdv/RealTimeIdv'
import TrustReport from '../../screens/TrustReport/TrustReport'
import KycButton from '../form/Button/Button'
// Refactored.
import ConsumerTrace from '../../screens/ConsumerTrace/ConsumerTrace'
import SpiderSearch from '../../screens/SpiderSearch/SpiderSearch'
import { BankAccountVerification } from '../../screens/BankAccountVerification/BankAccountVerification'
import FaceView from '../../screens/FaceView/FaceView'
import DeedsOfficePerson from '../../screens/DeedsOfficePerson/DeedsOfficePerson'
import DetailedBusinessReport from '../../screens/DetailedBusinessReport/DetailedBusinessReport'
import ReportHistory from '../../screens/ReportHistory/ReportHistory'
import SanctionScreening from '../../screens/SanctionScreening/SanctionScreening'
import CipcReport from '../../screens/CipcReport/CipcReport'
import CreditReportById from '../../screens/CreditReportById/CreditReportById'
import Precheck from '../../screens/Precheck/Precheck'
import { ReportResponseForm } from './ReportResponseForm'
import { sendOtp } from '../../api/common/sendOtp'
import { validateOtpAndGetReportId } from '../../api/creditEnquiry/validateOtpAndGetReportId'
import {
  HandleUserAuthenticateResponse,
  handleUserAuthenticate,
} from '../../api/auth/authenticateUser'
import { downloadCreditReport } from '../../api/kycPopupComponent/downloadCreditReport'
import NewButton from '../form/NewAndCloseButtons/NewButton'
import { ReportTypes } from '../../api/apiConstants'
import { Person } from '../../screens/CreditReportById/CreditReportById'
import BridgingFinance from '../../screens/BridgingFinance/BridgingFinance'
import BridgeTwo from '../../screens/BridgingFinance/BridgeTwo'
import BridgeThree from '../../screens/BridgingFinance/BridgeThree'
import BridgeNewSearch, {
  PropertyType,
} from '../../screens/BridgingFinance/BridgeNewSearch'
import TitleDeed from '../../screens/TitleDeed/TitleDeed'
import DeedsQuery from '../../screens/DeedsQuery/DeedsQuery'
import EuaEnquiry from '../../screens/EuaEnquiry/EuaEnquiry'
import { useMutation, useQuery } from 'react-query'
import {
  PropertyDetailsRequest,
  PropertyDetailsResponse,
  getPropertyDetails,
} from '../../api/bridgingFinance/getPropertyDetails'
import { useSelectedProperty } from '../BridgingFinance/store'
import Dots from '../../screens/DeedsOfficeSearches/Dots'
import { getBridgingApprovalStatus } from '../../api/bridgingFinance/getBridgingApprovalStatus'
import { RxCross1 } from 'react-icons/rx'

export type ActiveReport =
  | ''
  | 'REPORT_BY_ID'
  | 'PRECHECK'
  | 'CIPC'
  | 'SANCTION_SCREENING'
  | 'HISTORY'
  | 'BUSINESS'
  | 'DEEDS_OFFICE'
  | 'DOTS'
  | 'FACE_VIEW'
  | 'SPIDER_SEARCH'
  | 'BANK_ACCOUNT_VERIFICATION'
  | 'CONSUMER_TRACE'
  | 'TRUST'
  | 'Realtime_Idv'
  | 'DIRECTOR_ENQUIRY'
  | 'BRIDGING_FINANCE'
  | 'BRIDGE_TWO'
  | 'BRIDGE_THREE'
  | 'BRIDGE_NEW'
  | 'TITLE_DEED'
  | 'DEEDS_QUERY'
  | 'EUA_ENQUIRY'

export default function KycPopupComponent() {
  // Refactored.
  const [hfAgentID, setHfAgentID] = useState('')
  const [hfSubscriberID, setHfSubscriberID] = useState(1000)
  const [hfOwner, setHfOwner] = useState('')
  const [hfSuburb, setHfSuburb] = useState('')
  const [hfCMAID, setHfCMAID] = useState<number>(3035217)
  const [hfSchemeNo, setHfSchemeNo] = useState(0)
  const [hfSectionNo, setHfSectionNo] = useState(0)
  const [hfIsScheme, sethfIsScheme] = useState('')
  const [hfMunicipality, setHfMunicipality] = useState('')
  const [hfErfNo, setHfErfNo] = useState('')
  const [hfAddressDetails, setHfAddressDetails] = useState('')
  const [hfAddress, sethfAddress] = useState('')
  const [securityEstate, setSecurityEstate] = useState('')
  const [showDropdownBridging, setShowDropdownBridging] = useState(false)
  const [showDropdownDeeds, setShowDropdownDeeds] = useState(false)
  const [hfOwnerIDNo, setHfOwnerIDNo] = useState('')
  const [hfOwnerIDNoArray, setHfOwnerIDNoArray] = useState<string[]>([])
  const [activeReport, setActiveReport] = useState<ActiveReport>('PRECHECK')
  const [showDropdownBusiness, setDropdownBusiness] = useState(false)
  const [showDropdownPerson, setDropdownPerson] = useState(false)
  const [show, setShow] = useState(false)
  const [isRequestPage, setIsRequestPage] = useState(true)
  const [showOTPFields, setShowOTPFields] = useState(false)
  const [showDownloadReport, setShowDownloadReport] = useState(false)
  const [concent1, setFirstConcent] = useState(false)
  const [concent2, setSecondConcent] = useState(false)
  const [isError, setIsError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showProgress, setShowProgress] = useState(false)
  const [isValid, setIsValid] = useState(false)
  const [prodId, setProdId] = useState(14)
  const [OTPValue, setOTPValue] = useState('')
  const [KYCAccess, setKYCAccess] = useState(false)

  const [creditReportId, setCreditReportId] = useState<{
    data: { reportId: string }
  }>()
  const [titleScheme, setTitleScheme] = useState('')
  const [initialState, setInitialState] = useState(_initialState)
  const [identityNumber, setIdentityNumber] = useState('')
  const [passportNumber, setPassportNumber] = useState('')
  const [firstName, setFirstName] = useState('')
  const [surname, setSurname] = useState('')
  const [reportTypeId, setReportTypeId] = useState(0)
  const [reference, setReference] = useState('')
  const [creditReportPurpose, setCreditReportPurpose] = useState('')
  const [bridgeProperty, setBridgeProperty] = useState<PropertyType | null>(
    null,
  )
  const [hfIsAdmin, setHfIsAdmin] = useState(
    (document.getElementById('hfIsAdmin') as HTMLInputElement)?.value ||
      (process.env.REACT_APP_ENV === 'DEV' ? 'true' : ''),
  )

  useEffect(() => {
    const updateValueFromHtml = () => {
      const updatedValue =
        (document.getElementById('hfIsAdmin') as HTMLInputElement)?.value ||
        (process.env.REACT_APP_ENV === 'DEV' ? 'true' : '')
      setHfIsAdmin(updatedValue)
    }
    updateValueFromHtml()
    const timerId = setInterval(updateValueFromHtml, 5000)
    const stopTimerId = setTimeout(() => {
      clearInterval(timerId)
    }, 10000)
    return () => {
      clearInterval(timerId)
      clearTimeout(stopTimerId)
    }
  }, [])

  const [isBridgingApproved, setIsBridgingApproved] = useState(false)

  const sendOtpParams = {
    hfAgentID,
    setErrorMessage,
    setShowProgress,
    setIsError,
    setShowOTPFields,
  }
  const handleStartOver = () => {
    setUIDNumber({ target: { value: '' } })
    setFirstConcent(false)
    setSecondConcent(false)
    setShowDownloadReport(false)
    setReference('')
    setInitialState({
      ...initialState,
      creditReportById: {
        identityNumber: '',
        reference: '',
      },
    })
    setIsError(false)
    setErrorMessage('')
    setReportTypeId(0)
    setShowOTPFields(false)
  }

  const handleClick = () => {
    const downloadCreditReportParams = {
      creditReportId,
      setShowProgress,
      setIsError,
      setErrorMessage,
    }
    downloadCreditReport(downloadCreditReportParams)
  }

  const validateOtpAndGetReportIdParams = {
    identityNumber,
    OTPValue,
    hfAgentID,
    hfSubscriberID,
    setShowProgress,
    setIsError,
    setErrorMessage,
    setOTPValue,
    setShowDownloadReport,
    setCreditReportId,
    setShowOTPFields,
    reportTypeId,
    purpose: creditReportPurpose,
    reference,
    handleClick,
  }

  /**
   * Fetches authentication for CMA user. Triggers data fetches after successful authentication.
   */
  const { mutate: authenticate } = useMutation<HandleUserAuthenticateResponse>(
    'auth',
    handleUserAuthenticate,
    {
      onSuccess: (response) => {
        const root = document.getElementById('root')
        if (root) {
          document.body.appendChild(root)
        }
        setKYCAccess(!!response.data.KYCAccess)
        fetchBridgingFinanceProperty()
        fetchBridgingApprovalStatus()
      },
      onError: () => {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      },
    },
  )

  useEffect(() => {
    // get initial state on load
    const storedState = sessionStorage.getItem('initialState')
    if (storedState) {
      setInitialState(JSON.parse(storedState))
    } else {
      sessionStorage.setItem('initialState', JSON.stringify(_initialState))
    }
  }, [])
  //fetch any property details from api if property has already been selected
  const { addProperty } = useSelectedProperty()
  const {
    mutate: fetchSelectedProperty,
    isLoading: isLoadingSelectedProperty,
  } = useMutation<PropertyDetailsResponse, Error, PropertyDetailsRequest>(
    ['selectedProperty', hfCMAID, hfSectionNo, hfSchemeNo],
    getPropertyDetails,
    {
      onSuccess: (data) => {
        addProperty(data)
      },
    },
  )
  const fetchBridgingFinanceProperty = async () => {
    let hfCMAID = 0
    if (document.getElementById('hfCMAID')) {
      const el = document.getElementById('hfCMAID') as HTMLInputElement
      hfCMAID = parseInt(el.value)
    }
    let hfSectionNo = 0
    if (document.getElementById('hfSectionNo')) {
      const el = document.getElementById('hfSectionNo') as HTMLInputElement
      hfSectionNo = parseInt(el.value)
    }
    let hfSchemeName = ''
    if (document.getElementById('hfSchemeName')) {
      const el = document.getElementById('hfSchemeName') as HTMLInputElement
      hfSchemeName = el.value
    }
    if (!hfCMAID && !hfSectionNo && !hfSchemeName) return
    await fetchSelectedProperty({
      cmaid: hfCMAID,
      sectionNo: hfSectionNo,
      schemeNo: hfSchemeNo,
    })
  }
  const {
    mutate: fetchBridgingApprovalStatus,
    data,
    isLoading: isLoadingBridging,
  } = useMutation('bridging-status', getBridgingApprovalStatus, {
    onSuccess: () => {
      setIsBridgingApproved(true)
    },
    onError: () => {
      setIsBridgingApproved(false)
    },
  })

  useEffect(() => {
    //update initial state when it changes
    sessionStorage.setItem('initialState', JSON.stringify(initialState))
  }, [initialState])

  // Show modal.
  const handleShow = () => {
    //initiate authentication call and trigger data fetches
    if (document.getElementById('hfSuburb')) {
      const hfSuburb = document.getElementById('hfSuburb') as HTMLInputElement
      setHfSuburb(hfSuburb.value)
    }

    if (document.getElementById('hfErfNo')) {
      const hfErfNo = document.getElementById('hfErfNo') as HTMLInputElement
      setHfErfNo(hfErfNo.value)
    }

    if (document.getElementById('hfAddressDetails')) {
      const hfAddressDetails = document.getElementById(
        'hfAddressDetails',
      ) as HTMLInputElement
      setHfAddressDetails(hfAddressDetails.value)
    }
    //read hfCMAID
    if (document.getElementById('hfCMAID')) {
      const hfCMAID = document.getElementById('hfCMAID') as HTMLInputElement
      setHfCMAID(parseInt(hfCMAID.value))
    }

    //read hfSectionNo
    if (document.getElementById('hfSectionNo')) {
      const hfSectionNo = document.getElementById(
        'hfSectionNo',
      ) as HTMLInputElement
      setHfSectionNo(parseInt(hfSectionNo.value))
    }

    //read hfhfSchemeNo
    if (document.getElementById('hfSchemeNo')) {
      const hfSchemeNo = document.getElementById(
        'hfSchemeNo',
      ) as HTMLInputElement
      setHfSchemeNo(parseInt(hfSchemeNo.value))
    }

    //read hfIsScheme
    if (document.getElementById('hfIsScheme')) {
      const hfIsScheme = document.getElementById(
        'hfIsScheme',
      ) as HTMLInputElement
      console.log('hfIsScheme=', hfIsScheme.value)
      sethfIsScheme(hfIsScheme.value)
    }

    if (document.getElementById('hfAgentID')) {
      const hfAgentID = document.getElementById('hfAgentID') as HTMLInputElement
      setHfAgentID(hfAgentID.value)
    }

    if (document.getElementById('hfSubscriberID')) {
      const hfSubscriberID = document.getElementById(
        'hfSubscriberID',
      ) as HTMLInputElement
      setHfSubscriberID(parseInt(hfSubscriberID.value))
    }

    if (document.getElementById('hfOwner')) {
      const hfOwner = document.getElementById('hfOwner') as HTMLInputElement
      setHfOwner(hfOwner.value)

      if (hfOwner.value == '') {
        sethfIsScheme('true')
      }
    }
    if (document.getElementById('hfAddress')) {
      const hfAddress = document.getElementById('hfAddress') as HTMLInputElement
      sethfAddress(hfAddress.value)
    }

    if (document.getElementById('hfOwnerIDNo')) {
      const hfOwnerIDNo = document.getElementById(
        'hfOwnerIDNo',
      ) as HTMLInputElement
      setHfOwnerIDNo(hfOwnerIDNo.value)
    }
    authenticate()

    setHfOwnerIDNoArray(hfOwnerIDNo.split(';'))
    setDropdownBusiness(false)
    setShow(true)
    setDropdownPerson(true)
    setShowOTPFields(false)
    setShowDropdownDeeds(false)
    setShowDownloadReport(false)
    setShowDropdownBridging(false)
    setActiveReport('PRECHECK')
  }
  useEffect(() => {
    if (hfOwnerIDNo) {
      // Split hfOwnerIDNo.
      setHfOwnerIDNoArray(hfOwnerIDNo.split(';'))
    } else {
      setHfOwnerIDNoArray([])
    }
  }, [hfOwnerIDNo])

  const handleDropdownHidePerson = () => {
    setDropdownPerson(false)
    setIsError(false)
  }

  const handleDropdownPerson = () => {
    setShowDropdownDeeds(false)
    setDropdownPerson(true)
    setDropdownBusiness(false)
    setIsError(false)
    setActiveReport('PRECHECK')
    setShowOTPFields(false)
    setShowDropdownBridging(false)
  }

  const handleDropdownHideBusiness = () => {
    setDropdownBusiness(false)
    setIsError(false)
  }

  const handleDropdownBusiness = () => {
    setShowDropdownDeeds(false)
    setDropdownBusiness(true)
    setDropdownPerson(false)
    setActiveReport('CIPC')
    setShowOTPFields(false)
    setIsError(false)
    setShowDropdownBridging(false)
  }

  const handleDropdownDeeds = () => {
    setDropdownBusiness(false)
    setDropdownPerson(false)
    setActiveReport('DOTS')
    setShowOTPFields(false)
    setIsError(false)
    setShowDropdownBridging(false)
    setShowDropdownDeeds(true)
  }

  const handleDropdownReports = () => {
    setDropdownBusiness(false)
    setDropdownPerson(false)
    setActiveReport('HISTORY')
    setShowOTPFields(false)
    setIsError(false)
    setShowDropdownBridging(false)
    setShowDownloadReport(false)
    setShowDropdownDeeds(false)
  }

  const handleClose = () => {
    setProdId(14)
    setShow(false)
    setShowOTPFields(false)
    setShowProgress(false)
    setIsValid(false)
    setIdentityNumber('')
    setReportTypeId(0)
    setOTPValue('')
    setIsRequestPage(true)
    setFirstConcent(false)
    setShowDropdownDeeds(false)
    setSecondConcent(false)
  }

  const [loading, setLoading] = useState(false)
  const [creditSearchResults, setCreditSearchResults] = useState<Person[]>([])

  const handleActiveReport = (report: ActiveReport) => {
    setErrorMessage('')
    setShowOTPFields(false)
    setShowDownloadReport(false)
    setIdentityNumber('')
    setActiveReport(report)
    setFirstConcent(false)
    setSecondConcent(false)
    setSurname('')
    setFirstName('')
    setOTPValue('')
    setIsError(false)
    setReportTypeId(0)
    setCreditSearchResults([])
    setReference('')
    setCreditReportPurpose('')
  }

  // Form validation for credit report owner enquiry
  const validateFields = (
    handleMissing?: (missingFields: string[]) => void,
  ) => {
    let valid = true

    const missingFields = []

    if (prodId === null || prodId === 0) {
      valid = false
    }

    if (identityNumber === '' || identityNumber.trim() === '') {
      missingFields.push('Owner')
      valid = false
    }

    if (creditReportPurpose === '') {
      missingFields.push('Credit Report Purpose')
      valid = false
    }

    if (!concent1) {
      missingFields.push('Consent 1')
      valid = false
    }

    if (!concent2) {
      missingFields.push('Consent 2')
      valid = false
    }

    if (showOTPFields && OTPValue.toString().trim() === '') valid = false

    if (isValid !== valid) setIsValid(valid)
    if (handleMissing) handleMissing(missingFields)
    return valid
  }

  // User id handler for owner enquiry.
  const setUIDNumber = (uidNumber: {
    target: { value: React.SetStateAction<string> }
  }) => {
    setIdentityNumber(uidNumber.target.value)
  }

  // Handle search for owner enquiry.
  const handleSearch = (
    resend = false,
    downloadReport: (reportId?: string) => void,
  ) => {
    if (resend) sendOtp(sendOtpParams)
    if (!showOTPFields && validateFields()) sendOtp(sendOtpParams)
    if (showOTPFields && validateFields())
      validateOtpAndGetReportId({
        ...validateOtpAndGetReportIdParams,
        downloadReport,
      })
  }
  const handleCloseBridingFinance = () => {
    setActiveReport('BRIDGING_FINANCE')
    setShowDownloadReport(false)
    setShowOTPFields(false)
    setShowDropdownBridging(false)
    setIsError(false)
  }
  const handleNavToBridgingFinance = () => {
    setShowDropdownDeeds(false)
    setShowDropdownBridging(true)
    setDropdownBusiness(false)
    setIsError(false)
    setDropdownPerson(false)
    // if (isBridgingApproved) {
    //   return setActiveReport('BRIDGE_TWO')
    // }
    return setActiveReport('BRIDGING_FINANCE')
  }

  return (
    <>
      <Button variant="primary" onClick={handleShow} className="landingButton">
        KYC
      </Button>
      <Modal
        animation={false}
        show={show}
        //onHide={handleClose}
        size="lg"
        id="handle"
        className="handle"
        dialogClassName="dialogStyling"
        backdropClassName="backdropStyling"
      >
        {isRequestPage && (
          <>
            <Modal.Header className="modal-header1" onClick={handleClose}>
              <Modal.Title>
                Know Your Client
                <RxCross1
                  onClick={handleClose}
                  color="white"
                  cursor="pointer"
                />
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="itemsWrapper fullHeight">
                <div className="sideBarWrapper">
                  {!showDropdownPerson ? (
                    <SidebarMenu className="sideBarItemDivPerson">
                      <button
                        className="sideBarHeader"
                        onClick={handleDropdownPerson}
                      >
                        Person
                      </button>
                    </SidebarMenu>
                  ) : (
                    <div>
                      <SidebarMenu className="sideBarItemDivPerson">
                        <button
                          className={
                            activeReport !== 'HISTORY'
                              ? 'sideBarHeader2'
                              : 'sideBarHeader'
                          }
                          onClick={handleDropdownHidePerson}
                        >
                          Person
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem sideBarSubItem ${
                            activeReport === 'PRECHECK' ? 'btn-active' : ''
                          }`}
                          onClick={() => {
                            handleActiveReport('PRECHECK')
                            setShowDownloadReport(false)
                            setShowOTPFields(false)
                          }}
                        >
                          PRE-Check
                        </button>
                      </SidebarMenu>

                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'REPORT_BY_ID' ? 'btn-active' : ''
                          }`}
                          onClick={() => {
                            handleActiveReport('REPORT_BY_ID')
                          }}
                        >
                          Credit Report
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'Realtime_Idv' ? 'btn-active' : ''
                          }`}
                          onClick={() => handleActiveReport('Realtime_Idv')}
                        >
                          Real Time IDV
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'FACE_VIEW' ? 'btn-active' : ''
                          }`}
                          onClick={() => handleActiveReport('FACE_VIEW')}
                        >
                          Faceview
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'CONSUMER_TRACE'
                              ? 'btn-active'
                              : ''
                          }`}
                          onClick={() => handleActiveReport('CONSUMER_TRACE')}
                        >
                          Consumer Trace
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'SANCTION_SCREENING'
                              ? 'btn-active'
                              : ''
                          }`}
                          onClick={() => {
                            handleActiveReport('SANCTION_SCREENING')
                          }}
                        >
                          Sanction Screening
                        </button>
                      </SidebarMenu>
                      {hfIsAdmin === 'true' && (
                        <SidebarMenu className="sideBarItemDiv">
                          <button
                            className={`sideBarItem ${
                              activeReport === 'BANK_ACCOUNT_VERIFICATION'
                                ? 'btn-active'
                                : ''
                            }`}
                            onClick={() => {
                              setActiveReport('BANK_ACCOUNT_VERIFICATION')
                              setReportTypeId(
                                ReportTypes.BankVerificationSearchConsumer
                                  .reportTypeId,
                              )
                              setShowOTPFields(false)
                              setIsError(false)
                            }}
                          >
                            Bank Account Verification
                          </button>
                        </SidebarMenu>
                      )}
                    </div>
                  )}
                  {!showDropdownBusiness ? (
                    <SidebarMenu className="sideBarItemDiv">
                      <button
                        className="sideBarHeader"
                        onClick={handleDropdownBusiness}
                      >
                        Business
                      </button>
                    </SidebarMenu>
                  ) : (
                    <div>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={
                            activeReport !== 'HISTORY'
                              ? 'sideBarHeader2'
                              : 'sideBarHeader'
                          }
                          onClick={handleDropdownHideBusiness}
                        >
                          Business
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          type="button"
                          className={`sideBarItem sideBarSubItem ${
                            activeReport === 'CIPC' ? 'btn-active' : ''
                          }`}
                          onClick={() => {
                            setActiveReport('CIPC')
                            setReportTypeId(
                              ReportTypes.CIPCBusinessReport.reportTypeId,
                            )
                            setShowOTPFields(false)
                            setIsError(false)
                          }}
                        >
                          CIPC Report
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'BUSINESS' ? 'btn-active' : ''
                          }`}
                          onClick={() => {
                            setActiveReport('BUSINESS')
                            setReportTypeId(
                              ReportTypes.DetailedBusinessReport.reportTypeId,
                            )
                            setShowOTPFields(false)
                            setIsError(false)
                          }}
                        >
                          Detailed Business Report
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'DIRECTOR_ENQUIRY'
                              ? 'btn-active'
                              : ''
                          }`}
                          onClick={() => {
                            setActiveReport('DIRECTOR_ENQUIRY')
                            setReportTypeId(
                              ReportTypes.CIPCDirectorEnquiryReport
                                .reportTypeId,
                            )
                            setShowOTPFields(false)
                            setIsError(false)
                          }}
                        >
                          Director Enquiry
                        </button>
                      </SidebarMenu>
                    </div>
                  )}
                  {/* TODO: uncomment once dots is tested on staging */}
                  {!showDropdownDeeds ? (
                    <div>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className="sideBarHeader"
                          onClick={handleDropdownDeeds}
                        >
                          Deeds Office Searches
                        </button>
                      </SidebarMenu>
                    </div>
                  ) : (
                    <>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`${
                            activeReport !== 'HISTORY'
                              ? 'sideBarHeader2'
                              : 'sideBarHeader'
                          }`}
                          onClick={() => {
                            setActiveReport('DOTS')
                            setShowDownloadReport(false)
                            setShowOTPFields(false)
                            setIsError(false)
                            setShowDropdownDeeds(false)
                          }}
                        >
                          Deeds Office Searches
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem sideBarSubItem ${
                            activeReport === 'DOTS' ? 'btn-active' : ''
                          }`}
                          onClick={() => {
                            handleActiveReport('DOTS')
                          }}
                        >
                          Dots Query
                        </button>
                      </SidebarMenu>
                      {hfIsScheme === 'false' ? (
                        <SidebarMenu className="sideBarItemDiv">
                          <button
                            className={`sideBarItem ${
                              activeReport === 'DEEDS_QUERY' ? 'btn-active' : ''
                            }`}
                            onClick={() => {
                              handleActiveReport('DEEDS_QUERY')
                            }}
                          >
                            Deeds Query
                          </button>
                        </SidebarMenu>
                      ) : (
                        ''
                      )}
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'TITLE_DEED' ? 'btn-active' : ''
                          }`}
                          onClick={() => {
                            handleActiveReport('TITLE_DEED')
                          }}
                        >
                          Title Deed
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'SPIDER_SEARCH' ? 'btn-active' : ''
                          }`}
                          onClick={() => {
                            setActiveReport('SPIDER_SEARCH')
                            setReportTypeId(
                              ReportTypes.SpiderSearchConsumer.reportTypeId,
                            )
                            setShowOTPFields(false)
                            setIsError(false)
                          }}
                        >
                          National Deeds Search
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'EUA_ENQUIRY' ? 'btn-active' : ''
                          }`}
                          onClick={() => {
                            setActiveReport('EUA_ENQUIRY')
                            setReportTypeId(
                              ReportTypes.SpiderSearchConsumer.reportTypeId,
                            )
                            setShowOTPFields(false)
                            setIsError(false)
                          }}
                        >
                          EUA Enquiry
                        </button>
                      </SidebarMenu>
                    </>
                  )}
                  {/* TODO: uncommment below once bridging finance has been tested on staging */}
                  {!showDropdownBridging ? (
                    <div>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className="sideBarHeader"
                          onClick={handleNavToBridgingFinance}
                        >
                          Bridging Finance
                        </button>
                      </SidebarMenu>
                    </div>
                  ) : (
                    <>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`${
                            activeReport !== 'HISTORY'
                              ? 'sideBarHeader2'
                              : 'sideBarHeader'
                          }`}
                          onClick={() => {
                            handleCloseBridingFinance()
                          }}
                        >
                          Bridging Finance
                        </button>
                      </SidebarMenu>
                      {/* <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem sideBarSubItem${
                            activeReport === 'BRIDGE_TWO' ? 'btn-active' : ''
                          }`}
                          onClick={() => {
                            setActiveReport('BRIDGE_TWO')
                            setShowOTPFields(false)
                            setIsError(false)
                          }}
                        >
                          Current Property
                        </button>
                      </SidebarMenu>
                      <SidebarMenu className="sideBarItemDiv">
                        <button
                          className={`sideBarItem ${
                            activeReport === 'BRIDGE_NEW' ? 'btn-active' : ''
                          }`}
                          onClick={() => {
                            setActiveReport('BRIDGE_NEW')
                            setReportTypeId(
                              ReportTypes.CIPCDirectorEnquiryReport
                                .reportTypeId,
                            )
                            setShowOTPFields(false)
                            setIsError(false)
                          }}
                        >
                          Search a Property
                        </button>
                      </SidebarMenu> */}
                    </>
                  )}
                  <SidebarMenu className="sideBarItemDiv">
                    <button
                      className={
                        activeReport === 'HISTORY'
                          ? 'sideBarHeader2'
                          : 'sideBarHeader'
                      }
                      onClick={handleDropdownReports}
                    >
                      History
                    </button>
                  </SidebarMenu>
                </div>
                <div className="formWrapper" style={{ height: '100%' }}>
                  <Form
                    style={{ height: '100%' }}
                    onSubmit={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                    }}
                  >
                    {activeReport === '' && (
                      <Form.Group>
                        <Form.Label>
                          <p className="darkGreyTextHeaders">CREDIT REPORT</p>
                          <button className="darkGreyButtonStandard">
                            DOWNLOAD
                          </button>
                        </Form.Label>
                        <button
                          className="darkGreyButtonStandard"
                          style={{
                            width: '35%',
                          }}
                        >
                          Close
                        </button>
                      </Form.Group>
                    )}
                    {isError && (
                      <div className="errorMessageAlert">
                        <Alert
                          variant="danger"
                          transition={false}
                          dismissible
                          onClose={() => {
                            setIsError(false)
                            setErrorMessage('')
                          }}
                        >
                          {errorMessage}
                        </Alert>
                      </div>
                    )}
                    {activeReport === '' && (
                      <Form.Group>
                        <Form.Label>
                          <p className="darkGreyTextHeaders">CREDIT REPORT</p>
                          <p className="lightGreyText">
                            The director information returned includes the
                            person's name, Id number and directorship status.
                            For each director listed, a list of other possible
                            matches will be returned. Note that the printed
                            version of the report does not reflect the other
                            possible matches for the director.
                          </p>
                        </Form.Label>
                        <PriceComponent price={35} />
                        <Form.Label className="disclaimer">
                          {DISCLAIMER}
                        </Form.Label>
                        <p className="blueSentence">
                          Please download and save your reports for future
                          access
                        </p>
                      </Form.Group>
                    )}
                    {activeReport === 'DOTS' && (
                      <Dots
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        hfErfNo={hfErfNo}
                        hfAddress={hfAddress}
                        hfMunicipality={hfMunicipality}
                        hfSuburb={hfSuburb}
                        setShow={setShow}
                        setActiveReport={setActiveReport}
                        hfOwner={hfOwner}
                        hfOwnerIDNoArray={hfOwnerIDNoArray}
                        identityNumber={identityNumber}
                        setReportTypeId={setReportTypeId}
                        setIdentityNumber={setIdentityNumber}
                      />
                    )}
                    {activeReport === 'DEEDS_QUERY' && (
                      <DeedsQuery
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        setShow={setShow}
                        KYCAccess={KYCAccess}
                      />
                    )}
                    {activeReport === 'TITLE_DEED' && (
                      <TitleDeed
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        setShow={setShow}
                        KYCAccess={KYCAccess}
                      />
                    )}
                    {activeReport === 'BRIDGING_FINANCE' && (
                      <BridgingFinance
                        setShow={setShow}
                        setActiveReport={setActiveReport}
                        setShowDropdownBridging={setShowDropdownBridging}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                      />
                    )}
                    {activeReport === 'BRIDGE_TWO' && (
                      <BridgeTwo
                        hfAddressDetails={hfAddressDetails}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        hfErfNo={hfErfNo}
                        hfAddress={hfAddress}
                        hfMunicipality={hfMunicipality}
                        hfSuburb={hfSuburb}
                        setShow={setShow}
                        setActiveReport={setActiveReport}
                        hfOwner={hfOwner}
                        hfOwnerIDNoArray={hfOwnerIDNoArray}
                        identityNumber={identityNumber}
                        setReportTypeId={setReportTypeId}
                        setIdentityNumber={setIdentityNumber}
                      />
                    )}
                    {activeReport === 'BRIDGE_THREE' && (
                      <BridgeThree
                        setShow={setShow}
                        setActiveReport={setActiveReport}
                      />
                    )}
                    {activeReport === 'BRIDGE_NEW' && (
                      <BridgeNewSearch
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        setShow={setShow}
                        setActiveReport={setActiveReport}
                        setReportTypeId={setReportTypeId}
                      />
                    )}

                    {activeReport === 'REPORT_BY_ID' && (
                      <CreditReportById
                        setShow={setShow}
                        creditSearchResults={creditSearchResults}
                        setCreditSearchResults={setCreditSearchResults}
                        handleClose={handleClose}
                        identityNumber={identityNumber}
                        setUIDNumber={setUIDNumber}
                        passportNumber={passportNumber}
                        setUPPNumber={setPassportNumber}
                        firstName={firstName}
                        setFirstName={setFirstName}
                        surname={surname}
                        setSurname={setSurname}
                        creditReportPurpose={creditReportPurpose}
                        setCreditReportPurpose={setCreditReportPurpose}
                        concent1={concent1}
                        setFirstConcent={setFirstConcent}
                        concent2={concent2}
                        setSecondConcent={setSecondConcent}
                        showOTPFields={showOTPFields}
                        showDownloadReport={showDownloadReport}
                        showProgress={showProgress}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                        setReportType={setReportTypeId}
                        reference={reference}
                        KYCAccess={KYCAccess}
                        setReference={setReference}
                        handleClick={handleClick}
                        handleStartOver={handleStartOver}
                      />
                    )}
                    {activeReport === 'PRECHECK' && (
                      <Precheck
                        setShow={setShow}
                        handleClose={handleClose}
                        identityNumber={identityNumber}
                        setUIDNumber={setUIDNumber}
                        passportNumber={passportNumber}
                        firstName={firstName}
                        setFirstName={setFirstName}
                        surname={surname}
                        setSurname={setSurname}
                        creditReportPurpose={creditReportPurpose}
                        setCreditReportPurpose={setCreditReportPurpose}
                        concent1={concent1}
                        setFirstConcent={setFirstConcent}
                        concent2={concent2}
                        setSecondConcent={setSecondConcent}
                        showOTPFields={showOTPFields}
                        showDownloadReport={showDownloadReport}
                        showProgress={showProgress}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                        setReportType={setReportTypeId}
                        reference={reference}
                        KYCAccess={KYCAccess}
                        setReference={setReference}
                        handleClick={handleClick}
                        handleStartOver={handleStartOver}
                      />
                    )}
                    {activeReport === 'CIPC' && (
                      <CipcReport
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                        KYCAccess={KYCAccess}
                      />
                    )}
                    {activeReport === 'CONSUMER_TRACE' && (
                      <ConsumerTrace
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                        KYCAccess={KYCAccess}
                      />
                    )}
                    {activeReport === 'Realtime_Idv' && (
                      <RealTimeIdv
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                        KYCAccess={KYCAccess}
                      />
                    )}
                    {activeReport === 'TRUST' && (
                      <TrustReport
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                      />
                    )}
                    {activeReport === 'BUSINESS' && (
                      <DetailedBusinessReport
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                        KYCAccess={KYCAccess}
                      />
                    )}
                    {activeReport === 'HISTORY' && (
                      <ReportHistory
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                      />
                    )}
                    {activeReport === 'SPIDER_SEARCH' && (
                      <SpiderSearch
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                      />
                    )}
                    {activeReport === 'EUA_ENQUIRY' && (
                      <EuaEnquiry
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        setShow={setShow}
                        KYCAccess={KYCAccess}
                        handleClose={handleClose}
                      />
                    )}
                    {activeReport === 'BANK_ACCOUNT_VERIFICATION' && (
                      <BankAccountVerification
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                        KYCAccess={KYCAccess}
                      />
                    )}
                    {activeReport === 'FACE_VIEW' && (
                      <FaceView
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                        KYCAccess={KYCAccess}
                      />
                    )}
                    {activeReport === 'DEEDS_OFFICE' && (
                      <DeedsOfficePerson
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                      />
                    )}
                    {activeReport === 'SANCTION_SCREENING' && (
                      <SanctionScreening
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                      />
                    )}
                    {/*{activeReport === 'BANK_ACCOUNT_VERIFICATION' && (*/}
                    {/*  <BankAccountVerification*/}
                    {/*    setShow={setShow}*/}
                    {/*    setIsError={setIsError}*/}
                    {/*    setErrorMessage={setErrorMessage}*/}
                    {/*    initialState={initialState}*/}
                    {/*    setInitialState={setInitialState}*/}
                    {/*  />*/}
                    {/*)}*/}
                    {activeReport === 'DIRECTOR_ENQUIRY' && (
                      <DirectorEnquiry
                        setShow={setShow}
                        setIsError={setIsError}
                        setErrorMessage={setErrorMessage}
                        initialState={initialState}
                        setInitialState={setInitialState}
                        KYCAccess={KYCAccess}
                      />
                    )}
                    {showOTPFields &&
                      activeReport !== 'BRIDGING_FINANCE' &&
                      !showDownloadReport && (
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="KYCForm.ControlInput2"
                        >
                          <p>
                            Please enter the OTP that has been sent to your
                            registered email address. <br />
                            <KycButton
                              variant={'primary'}
                              children={'Resend OTP'}
                              onClick={() => {
                                setShowOTPFields(false)
                                sendOtp(sendOtpParams)
                                setOTPValue('')
                              }}
                            />
                          </p>
                          <Form.Group
                            className="mb-3"
                            controlId="KYCForm.ControlInput2"
                          >
                            {/* <Form.Label className="IDText mb-0">OTP.</Form.Label> */}
                            <Form.Control
                              type="input"
                              value={OTPValue}
                              placeholder="Please enter the OTP that has been sent to your registered email address."
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                  e.preventDefault()
                                }
                              }}
                              onChange={(val) => {
                                setOTPValue(val.target.value)
                              }}
                            />
                          </Form.Group>
                          <div className="footer-btns">
                            <Button
                              className="btn-lg btn-kyc"
                              onClick={() =>
                                validateOtpAndGetReportId({
                                  ...validateOtpAndGetReportIdParams,
                                  downloadReport: () => {},
                                })
                              }
                              disabled={OTPValue.length === 0}
                            >
                              {showProgress && (
                                <>
                                  <Spinner
                                    as="span"
                                    size="sm"
                                    animation="border"
                                    variant="dark"
                                    role="status"
                                    aria-hidden="true"
                                  ></Spinner>
                                  <span> </span>
                                </>
                              )}
                              Verify
                            </Button>
                            <Button
                              className="btn-lg btn-kyc-inverse m-l-10"
                              style={{
                                backgroundColor: 'rgb(255, 255, 255)',
                                borderColor: '#7f7f7f',
                                color: '#7f7f7f',
                              }}
                              onClick={() => setShow(false)}
                            >
                              Close
                            </Button>
                          </div>
                          <div className="btn-group">
                            {(showOTPFields || showDownloadReport) && (
                              <NewButton handleAction={handleStartOver} />
                            )}
                          </div>
                        </Form.Group>
                      )}
                  </Form>
                </div>
              </div>
            </Modal.Body>
          </>
        )}
      </Modal>
    </>
  )
}
